import { Box, Stack, TextField, Typography } from '@mui/material';
import type { User } from '/@/hooks/nodes';
import { _ } from '/@/locale';

const FieldviewSection = ({ growerFieldviewData }: { growerFieldviewData: User }) => {
    return (
        <Stack className='mp-mask' spacing={2} direction='column'>
            <Stack direction='column' spacing={0.5}>
                <Typography
                    variant='subtitle1'
                    fontWeight='bold'
                    color='primary'
                    sx={{ textAlign: 'start', width: '100%' }}
                >
                    {_('Cuenta vinculada de Fieldview')}
                </Typography>
                <Typography variant='subtitle1' color='primary' sx={{ textAlign: 'start', width: '100%' }}>
                    {_('Datos que provienen de la conexión autorizada por el productor')}
                </Typography>
            </Stack>
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
                    gap: 2,
                    width: '100%',
                }}
            >
                <TextField
                    label={_('Nombre')}
                    value={`${growerFieldviewData?.firstName} ${growerFieldviewData?.lastName}`}
                    fullWidth
                    disabled
                />
                <TextField label={_('Email')} value={growerFieldviewData?.email} fullWidth disabled />
            </Box>
        </Stack>
    );
};

export default FieldviewSection;
